import { faltaDeEmbalagem } from './embalagem'
import { converterFatorEmbalagem } from '../importacao/validacao'
import { precoDigitado } from '../precos/entradaPreco'
import type { FaltaDaLinha } from '../precos/rascunhoDaTabela'

// ▶ "Corrigir" do card vermelho da tabela (pedido dela 01/10): abre o produto
// direto em EDITAR, pinta de vermelho o que falta, e o Salvar volta para a
// tabela. Mesmo molde do "+ Produto novo" (voltarParaTabela.ts).
export function destinoDeCorrigir(produtoId: string, tabelaId: string, faltas: FaltaDaLinha[]): string {
  const voltar = encodeURIComponent(`/tabelas/${tabelaId}`)
  // A comissao nao tem campo na tela do produto -- mora no card da tabela.
  const semComissao = faltas.includes('comissao') ? '&semComissao=1' : ''
  return `/produtos/${encodeURIComponent(produtoId)}?editar=1&tabela=${encodeURIComponent(tabelaId)}&voltar=${voltar}${semComissao}`
}

// So aceita /tabelas/..., para o endereco nao virar um redirecionamento para
// qualquer lugar (mesma trava do destinoAoCriarProduto).
export function voltarDoCorrigir(params: URLSearchParams): string | null {
  const voltar = params.get('voltar')
  if (params.get('editar') !== '1' || !voltar || !/^\/tabelas\/[^/?#]+$/.test(voltar)) return null
  return voltar
}

// O que pintar de vermelho, AO VIVO: some assim que ela digita. A regra da
// embalagem e a MESMA do card (faltaDeEmbalagem).
export function faltasNoCadastro(c: { unidade: string; qtd: string; preco: string; semComissao: boolean }) {
  const embalagem = faltaDeEmbalagem({ unidade: c.unidade, unidades_por_embalagem: converterFatorEmbalagem(c.qtd) ?? null })
  const preco = precoDigitado(c.preco)
  return { tipo: embalagem === 'tipo', qtd: embalagem === 'qtd', preco: preco === null || !(preco > 0), comissao: c.semComissao }
}
